export * from "./Dict2Tab";
